import { render, staticRenderFns } from "./V2CartTotal.vue?vue&type=template&id=07438326&"
import script from "./V2CartTotal.vue?vue&type=script&lang=js&"
export * from "./V2CartTotal.vue?vue&type=script&lang=js&"
import style0 from "./V2CartTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports